import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import styles from "./MassMailing.module.css";
import SalesRecruiter from "../../components/common/SalesRecruiter";
import profile_image from "../../assets/images/ajit_image.jpeg";
import { TiTick } from "react-icons/ti";

const MassSalesMailing = () => {
  const [candidates, setCandidates] = useState([
    {
      id: 1,
      name: "Ramesh Kumar Bhatta",
      email: "ramesh@*****olutions.com",
      match: "12",
      selected: false,
    },
    {
      id: 2,
      name: "Swomiya Bhatta",
      email: "amiya@*****olutions.com",
      match: "25",
      selected: false,
    },
    {
      id: 3,
      name: "Kaibalya Bhatta",
      email: "kaibalya@*****olutions.com",
      match: "17",
      selected: false,
    },
    {
      id: 4,
      name: "Swomiya Bhatta",
      email: "amiya@*****olutions.com",
      match: "12",
      selected: false,
    },
    {
      id: 5,
      name: "Swomiya Bhatta",
      email: "amiya@*****olutions.com",
      match: "12",
      selected: false,
    },
  ]);

  const [selectAll, setSelectAll] = useState(false);

  const handleSelect = (id) => {
    const updatedCandidates = candidates.map((candidate) =>
      candidate.id === id
        ? { ...candidate, selected: !candidate.selected }
        : candidate
    );
    setCandidates(updatedCandidates);
    setSelectAll(updatedCandidates.every((candidate) => candidate.selected));
  };

  const handleSelectAll = () => {
    const updatedSelectAll = !selectAll;
    setSelectAll(updatedSelectAll);
    const updatedCandidates = candidates.map((candidate) => ({
      ...candidate,
      selected: updatedSelectAll,
    }));
    setCandidates(updatedCandidates);
  };

  return (
    // <RootComponents>
      <Box className={styles.mass_new_structure}>
        <Box className={styles.mass_new_header_text}>
          <Typography>All Active Bench Sales Recruiter</Typography>
        </Box>
        <Box className={styles.requiter_profile_section}>
          {candidates.map((candidate) => {
            return (
              <SalesRecruiter
                image={profile_image}
                name={candidate.name}
                emailID={candidate.email}
                status={candidate.match}
                handleSelect={handleSelect}
                candidateId={candidate.id}
                btn2={
                  <>
                    {candidate.selected === true ? (
                      <>
                        Selected <TiTick style={{ color: "#fff" }} />
                      </>
                    ) : (
                      "Select"
                    )}
                  </>
                }
              />
            );
          })}
        </Box>
        <Box className={styles.mass_update_btns}>
          <button 
            style={{ backgroundColor: "#3856a6", marginRight:'0' }}onClick={handleSelectAll}>
            {selectAll ? "Deselect All" : "Select All"}
          </button>
        </Box>
      </Box>
    // </RootComponents>
  );
};

export default MassSalesMailing;
